import { render, staticRenderFns } from "./VolunteerManage.vue?vue&type=template&id=d35a34ec&scoped=true"
import script from "./VolunteerManage.vue?vue&type=script&lang=js"
export * from "./VolunteerManage.vue?vue&type=script&lang=js"
import style0 from "./VolunteerManage.vue?vue&type=style&index=0&id=d35a34ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35a34ec",
  null
  
)

export default component.exports